module.exports = __webpack_public_path__ + "media/images/flags/16/French-Polynesia-c36a1f8206619dea185a4665b8782afd.png";